export default {
  slogan: 'Pasión por las ideas'
}



// WEBPACK FOOTER //
// ./src/i18n/es/general.js